import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import { stringHueColor } from '../../utils/workspaceFormat';

function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0] || '?').slice(0, 2).toUpperCase();
}

export default function SettingsAgentsPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const agents = data?.workspace?.agents || [];

  return (
    <MainPanel title={t('settingsPages.agentsTitle')} subtitle={t('settingsPages.agentsSubtitle')}>
      {agents.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('settingsPages.agentsEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('settingsPages.agentsEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {agents.map((a) => (
            <div
              key={a.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: '16px 20px',
                background: '#1f2229',
                borderRadius: 12,
                border: '1px solid rgba(255,255,255,0.06)',
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  background: stringHueColor(a.email || a.fullName),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: 14,
                  color: '#fff',
                }}
              >
                {initials(a.fullName)}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, color: '#f3f4f6' }}>{a.fullName}</div>
                <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 4 }}>{a.email}</div>
              </div>
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  textTransform: 'capitalize',
                  padding: '4px 10px',
                  borderRadius: 999,
                  background:
                    a.status === 'online' ? '#14532d' : a.status === 'busy' ? '#713f12' : '#374151',
                  color: a.status === 'online' ? '#bbf7d0' : a.status === 'busy' ? '#fde68a' : '#d1d5db',
                }}
              >
                {a.status || 'offline'}
              </span>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
